var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-layout',{attrs:{"justify-center":"","align-center":""}},[_c('register-panel',{attrs:{"app-name":_vm.appName,"studio-org":_vm.studioOrg}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }